/**
 * Vulnerability Action Handlers Hook
 *
 * Main coordinator hook for vulnerability action handlers.
 * Composes scan handlers with other action types (status, share, etc.)
 *
 * @module sections/vulnerabilities/hooks/actions
 */

import { VulnerabilityActionHandlers } from '@/sections/vulnerabilities/types/action.types';
import { Risk } from '@/types';

import { useVulnerabilityScanHandlers } from './useVulnerabilityScanHandlers';
import { useVulnerabilityShareHandlers } from './useVulnerabilityShareHandlers';

/**
 * Main coordinator hook for vulnerability action handlers
 * Composes all action handlers into a single interface
 *
 * Pattern matches useAssetActionHandlers for consistency
 *
 * @param selectedVulnerabilities - Currently selected vulnerabilities
 * @param onScanComplete - Optional callback after scan actions complete
 * @returns Combined action handlers interface
 */
export const useVulnerabilityActionHandlers = (
  selectedVulnerabilities: Risk[],
  onScanComplete?: () => void
): VulnerabilityActionHandlers => {
  const scanHandlers = useVulnerabilityScanHandlers(onScanComplete);
  const shareHandlers = useVulnerabilityShareHandlers(selectedVulnerabilities);

  // Future: Add status handlers, etc.
  // const statusHandlers = useVulnerabilityStatusHandlers();

  return {
    ...scanHandlers,
    ...shareHandlers,
    // ...statusHandlers,
  };
};
